export const LOGIN_URL = "http://127.0.0.1:8000/rest-auth/login/";
export const REGISTER_URL = "http://127.0.0.1:8000/rest-auth/registration/";
export const JOB_POSTING_URL = "http://127.0.0.1:8000/";
export const JOB_SEARCH_URL = "http://localhost:8000/?search=";
